import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import ResetPassword from '@/views/ResetPassword'
import AccessDenied from '@/views/AccessDenied'
import ReportList from '@/views/reports/List'
import PlatformHistory from '@/views/reports/PlatformHistory'
import Plans from '@/views/plans/Plans'
import APLibrary from '@/views/actionpoints/library/Library'
import APManager from '@/views/actionpoints/Manager'
import DevicesList from '@/views/devices/List'
import DevicesForm from '@/views/devices/Form'
import DevicesBulk from '@/views/devices/Bulk'
import DevicesGroupsList from '@/views/devices/groups/List'
import DevicesGroupsForm from '@/views/devices/groups/Form'
import DevicesNotificationsList from '@/views/devices/notifications/List'
import DevicesNotifications from '@/views/devices/Notifications'
import IdentificationsList from '@/views/identifications/List'
import IdentificationsForm from '@/views/identifications/Form'
import ProfilesList from '@/views/profiles/List'
import ProfilesForm from '@/views/profiles/Form'
import PlanningList from '@/views/planning/List'
import PlanningForm from '@/views/planning/Form'
import PhonebooksList from '@/views/phonebooks/List'
import PhonebooksForm from '@/views/phonebooks/Form'
import PPEsList from '@/views/ppes/List'
import PPEsForm from '@/views/ppes/Form'
import PatrolsList from '@/views/patrols/List'
import PatrolsForm from '@/views/patrols/Form'
import PatrolsCompare from '@/views/patrols/Compare'
import PatrolsPlanning from '@/views/patrols/Planning'
import PatrolsListing from "@/views/patrols/PatrolsListing";
import RemoteMonitoringList from '@/views/remoteMonitoring/List'
import RemoteMonitoringShow from '@/views/remoteMonitoring/Show'
import RemoteMonitoringForm from '@/views/remoteMonitoring/Form'
import RemoteMonitoringLogs from '@/views/remoteMonitoring/Log'
import WatchmenList from '@/views/watchmen/List'
import WatchmenForm from '@/views/watchmen/Form'
import TOSForm from '@/views/tos/Form'
import UserMeForm from '@/views/settings/MeForm'
import Offers from "@/views/settings/Offers";
import ChannelConfirmation from '@/views/ChannelConfirmation'
import CertificateIndex from '@/views/certificate/Index'
import TemporaryWatchmanConfirmation from '@/views/TemporaryWatchmanConfirmation'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import News from '@/views/News'
import Redirect from '@/views/Redirect'
import Auth from '@/services/auth.js'
import Utils from '@/services/utils.js'
import _filter from 'lodash/filter'
import _find from 'lodash/find'
import _indexOf from 'lodash/indexOf'
import _map from 'lodash/map'
import _intersection from 'lodash/intersection'
import axios from 'axios'

Vue.use(Router)

var router = new Router({
    routes: [

        /*------------------------------
         CONNEXION
         ------------------------------*/
        {
            path: '/login/:token?',
            name: 'Login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/forget-password',
            name: 'ResetPassword',
            component: ResetPassword,
            meta: {
                requiresAuth: false
            }
        },
        {
          path: '/access-denied/:slug',
          name: 'AccessDenied',
          component: AccessDenied,
          meta: {
            requiresAuth: true,
            fallback: '/home'
          }
        },

        /*------------------------------
         TEMPS REEL
         ------------------------------*/
        {
            path: '/home',
            name: 'Home',
            component: Home,
            meta: {
                requiresAuth: true,
                fallback:'/login',
                permission: 'beepiz-browse-dashboard'
            },

        },
        /*------------------------------
         RAPPORTS
         ------------------------------*/
        {
            path: '/reports/platform',
            name: 'PlatformHistory',
            component: PlatformHistory,
            meta: {
                requiresAuth: true,
                fallback:'/reports',
                permission: 'beepiz-browse-reports'
            },

        },
        {
            path: '/reports/:reportName?/:reportResources?/:reportPeriod?',
            name: 'Reports',
            component: ReportList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-reports'
            },

        },
        /*------------------------------
         LOCALISATION INTERIEURE
         ------------------------------*/
        {
            path: '/plans/manager',
            name: 'Plans',
            component: Plans,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-plans'
            }
        },
        {
            path: '/plans/manager/:planid',
            name: 'PlansForId',
            component: Plans,
            meta: {
                requiresAuth: true,
                fallback:'/plans/manager',
                permission: 'beepiz-browse-plans'
            }
        },

        {
            path: '/plans/actionpoints/manager',
            name: 'APManager',
            component: APManager,
            meta: {
                requiresAuth: true,
                fallback:'/plans/manager',
                permission: 'beepiz-browse-actionpoints'
            }
        },
        {
            path: '/plans/actionpoints/manager/:planid',
            name: 'APManagerForPlan',
            component: APManager,
            meta: {
                requiresAuth: true,
                fallback:'/plans/manager',
                permission: 'beepiz-browse-actionpoints'
            }
        },
        {
            path: '/plans/actionpoints/library',
            name: 'APLibrary',
            component: APLibrary,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-library'
            }
        },
        /*------------------------------
         DEVICES
         ------------------------------*/
        {
            path: '/devices/list',
            name: 'DevicesList',
            component: DevicesList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-devices'
            }
        },
        {
            path: '/devices/new',
            name: 'DevicesNew',
            component: DevicesForm,
            meta: {
                requiresAuth: true,
                fallback:'/devices/list',
                permission: 'beepiz-add-devices'
            }
        },
        {
            path: '/devices/groups',
            name: 'DevicesGroups',
            component: DevicesGroupsList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-groups'
            }
        },
        {
            path: '/devices/groups/new',
            name: 'DevicesGroupsNew',
            component: DevicesGroupsForm,
            meta: {
                requiresAuth: true,
                fallback:'/devices/groups',
                permission: 'beepiz-add-groups'
            }
        },
        {
            path: '/devices/groups/:id',
            name: 'DevicesGroupsShow',
            component: DevicesGroupsForm,
            meta: {
                requiresAuth: true,
                fallback:'/devices/groups',
                permission: 'beepiz-edit-groups'
            }
        },
        {
            path: '/devices/licences',
            name: 'DevicesBulk',
            component: DevicesBulk,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-licences'
            }
        },
        {
            path: '/devices/:id',
            name: 'DevicesShow',
            component: DevicesForm,
            meta: {
                requiresAuth: true,
                fallback:'/devices/list',
                permission: 'beepiz-browse-devices'
            }
        },
        /*------------------------------
         PROFILS DE CONFIGURATION
         ------------------------------*/
        {
            path: '/configurations/profiles',
            name: 'ProfilesList',
            component: ProfilesList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-profiles'
            }
        },
        {
            path: '/configurations/profiles/new',
            name: 'ProfilesNew',
            component: ProfilesForm,
            meta: {
                requiresAuth: true,
                fallback:'/configurations/profiles',
                permission: 'beepiz-browse-profiles'
            }
        },
        {
            path: '/configurations/profiles/:id',
            name: 'ProfilesShow',
            component: ProfilesForm,
            meta: {
                requiresAuth: true,
                fallback:'/configurations/profiles',
                permission: 'beepiz-browse-profiles'
            }
        },
        {
            path: '/configurations/profiles/:id/copy',
            name: 'ProfilesCopy',
            component: ProfilesForm,
            meta: {
                requiresAuth: true,
                specialAction: 'copy',
                fallback:'/configurations/profiles',
                permission: 'beepiz-browse-profiles'
            }
        },

        /*------------------------------
         Planning
         ------------------------------*/
        {
            path: '/parameters/planning',
            name: 'PlanningList',
            component: PlanningList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-profiles'
            }
        },
        {
            path: '/parameters/planning/new',
            name: 'PlanningNew',
            component: PlanningForm,
            meta: {
                requiresAuth: true,
                fallback:'/parameters/profiles',
                permission: 'beepiz-browse-profiles'
            }
        },
        {
            path: '/parameters/planning/:id',
            name: 'PlanningShow',
            component: PlanningForm,
            meta: {
                requiresAuth: true,
                fallback:'/parameters/profiles',
                permission: 'beepiz-browse-profiles'
            }
        },
        {
            path: '/parameters/planning/:id/copy',
            name: 'PlanningCopy',
            component: PlanningForm,
            meta: {
                requiresAuth: true,
                specialAction: 'copy',
                fallback:'/parameters/planning',
                permission: 'beepiz-browse-profiles'
            }
        },

        /*------------------------------
         EPIs
         ------------------------------*/
        {
            path: '/parameters/ppes',
            name: 'PPEsList',
            component: PPEsList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-ppes'
            }
        },
        {
            path: '/parameters/ppes/new',
            name: 'PPEsNew',
            component: PPEsForm,
            meta: {
                requiresAuth: true,
                fallback:'/parameters/ppes',
                permission: 'beepiz-browse-ppes'
            }
        },
        {
            path: '/parameters/ppes/:id',
            name: 'PPEsShow',
            component: PPEsForm,
            meta: {
                requiresAuth: true,
                fallback:'/parameters/ppes',
                permission: 'beepiz-browse-ppes'
            }
        },
        {
            path: '/parameters/ppes/:id/copy',
            name: 'PPEsCopy',
            component: PPEsForm,
            meta: {
                requiresAuth: true,
                specialAction: 'copy',
                fallback:'/parameters/ppes',
                permission: 'beepiz-browse-ppes'
            }
        },
        /*------------------------------
         ANNUAIRES
         ------------------------------*/
        {
            path: '/parameters/phonebooks',
            name: 'PhonebooksList',
            component: PhonebooksList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-phonebooks'
            }
        },
        {
            path: '/parameters/phonebooks/new',
            name: 'PhonebooksNew',
            component: PhonebooksForm,
            meta: {
                requiresAuth: true,
                fallback:'/parameters/phonebooks',
                permission: 'beepiz-browse-phonebooks'
            }
        },
        {
            path: '/parameters/phonebooks/:id',
            name: 'PhonebooksShow',
            component: PhonebooksForm,
            meta: {
                requiresAuth: true,
                fallback:'/parameters/phonebooks',
                permission: 'beepiz-browse-phonebooks'
            }
        },
        {
            path: '/parameters/phonebooks/:id/copy',
            name: 'PhonebooksCopy',
            component: PhonebooksForm,
            meta: {
                requiresAuth: true,
                specialAction: 'copy',
                fallback:'/parameters/phonebooks',
                permission: 'beepiz-browse-phonebooks'
            }
        },

        /*------------------------------
         CONTENU PERSONNALISE
         ------------------------------*/
        {
            path: '/parameters/tos',
            name: 'TOSForm',
            component: TOSForm,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-profiles'
            }
        },

        /*------------------------------
         RONDES
         ------------------------------*/
        {
            path: '/patrols/list',
            name: 'PatrolsList',
            component: PatrolsList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-patrols'
            }
        },
        {
          path: '/patrols/recent',
          name: 'PatrolsListing',
          component: PatrolsListing,
          meta: {
            requiresAuth: true,
            fallback:'/home',
            permission: 'beepiz-browse-patrols'
          }
        },
        {
            path: '/patrols/new',
            name: 'PatrolsNew',
            component: PatrolsForm,
            meta: {
                requiresAuth: true,
                fallback:'/patrols/list',
                permission: 'beepiz-browse-patrols'
            }
        },
        {
            path: '/patrols/compare',
            name: 'PatrolsCompare',
            component: PatrolsCompare,
            meta: {
                requiresAuth: true,
                fallback:'/patrols/list',
                permission: 'beepiz-compare-patrols'
            }
        },
        {
            path: '/patrols/planning',
            name: 'PatrolsPlanning',
            component: PatrolsPlanning,
            meta: {
                requiresAuth: true,
                fallback:'/patrols/list',
                permission: 'beepiz-browse-patrols'
            }
        },
        {
            path: '/patrols/:id',
            name: 'PatrolsShow',
            component: PatrolsForm,
            meta: {
                requiresAuth: true,
                fallback:'/patrols/list',
                permission: 'beepiz-browse-patrols'
            }
        },

        {
            path: '/patrols/:id/copy',
            name: 'PatrolsCopy',
            component: PatrolsForm,
            meta: {
                requiresAuth: true,
                specialAction: 'copy',
                fallback:'/patrols/list',
                permission: 'beepiz-browse-patrols'
            }
        },

        /*------------------------------
         WATCHMEN
         ------------------------------*/
         {
            path: '/configurations/watchmen',
            name: 'WatchmenList',
            component: WatchmenList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-watchmen'
            }
        },
        {
            path: '/configurations/watchmen/:id',
            name: 'WatchmenForm',
            component: WatchmenForm,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-watchmen'
            }
        },

        /*------------------------------
         TELEASSISTANCE
         ------------------------------*/
        {
            path: '/remotemonitoring',
            name: 'RemoteMonitoringList',
            component: RemoteMonitoringList,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-remotemonitoring'
            }
        },
        {
            path: '/remotemonitoring/logs',
            name: 'RemoteMonitoringLogs',
            component: RemoteMonitoringLogs,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-remotemonitoring'
            }
        },
        {
            path: '/remotemonitoring/new',
            name: 'RemoteMonitoringNew',
            component: RemoteMonitoringForm,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-remotemonitoring'
            }
        },
        {
            path: '/remotemonitoring/:id',
            name: 'RemoteMonitoringShow',
            component: RemoteMonitoringShow,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-remotemonitoring'
            }
        },
        {
            path: '/remotemonitoring/:id/edit',
            name: 'RemoteMonitoringForm',
            component: RemoteMonitoringForm,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'beepiz-browse-remotemonitoring'
            }
        },

        /*------------------------------
         MON COMPTE
         ------------------------------*/
        {
            path: '/settings/me',
            name: 'UserSettings',
            component: UserMeForm,
            meta: {
                requiresAuth: true,
                fallback:'/home',
                permission: 'global-access-beepiz'
            }
        },
        {
          path: '/settings/offers',
          name: 'AllOffers',
          component: Offers,
          meta: {
            requiresAuth: true,
            fallback:'/home',
            permission: 'global-access-beepiz'
          }
        },

        /*------------------------------
         AUTRES PARAMETRES
         ------------------------------*/
        /* NOTIFICATIONS */
        {
          path: '/parameters/notifications',
          name: 'DevicesNotifications',
          component: DevicesNotificationsList,
          meta: {
            requiresAuth: true,
            fallback:'/home',
            permission: 'beepiz-browse-devices'
          }
        },
        {
          path: '/parameters/notifications/new',
          name: 'DevicesNotificationsForm',
          component: DevicesNotifications,
          meta: {
            requiresAuth: true,
            fallback:'/parameters/notifications',
            permission: 'beepiz-browse-devices'
          }
        },
        /* IDENTIFICATIONS */
        {
          path: '/parameters/identifications',
          name: 'IdentificationsList',
          component: IdentificationsList,
          meta: {
            requiresAuth: true,
            fallback:'/home',
            permission: 'beepiz-browse-identifications'
          }
        },
        {
          path: '/parameters/identifications/new',
          name: 'IdentificationsNew',
          component: IdentificationsForm,
          meta: {
            requiresAuth: true,
            fallback:'/parameters/identifications',
            permission: 'beepiz-browse-identifications'
          }
        },
        {
          path: '/parameters/identifications/:id',
          name: 'IdentificationsShow',
          component: IdentificationsForm,
          meta: {
            requiresAuth: true,
            fallback:'/parameters/identifications',
            permission: 'beepiz-browse-identifications'
          }
        },
        {
          path: '/parameters/identifications/:id/copy',
          name: 'IdentificationsCopy',
          component: IdentificationsForm,
          meta: {
            requiresAuth: true,
            specialAction: 'copy',
            fallback:'/parameters/identifications',
            permission: 'beepiz-browse-identifications'
          }
        },
        {
          path: "/redirect/:redirectTo",
          name: "Redirect",
          component: Redirect,
          meta: {
            requiresAuth: true,
            fallback: '/home'
          }
        },
        /*------------------------------
         Certificate
        ------------------------------*/
        {
            path: "/certificate/",
            name: "CertificateIndex",
            component: CertificateIndex,
            meta: {
              requiresAuth: true,
              fallback: '/home'
            }
          },
        /*------------------------------
         News
        ------------------------------*/
        {
          path: "/news/",
          name: "News",
          component: News,
          meta: {
            requiresAuth: true,
            fallback: '/home'
          }
        },
        /*------------------------------
         CHANNEL VALIDATION
         ------------------------------*/
        {
          path: "/channel-validation/:callId",
          name: "ChannelConfirmation",
          component: ChannelConfirmation,
          meta: {
            requiresAuth: false,
            fallback: null,
            layout: 'public'
          }
        },
        /*------------------------------
         WATCHMAN
        ------------------------------*/
        {
          path: "/watch/:unique_id",
          name: "TemporaryWatchmanConfirmation",
          component: TemporaryWatchmanConfirmation,
          meta: {
            requiresAuth: false,
            fallback: null,
            layout: 'public'
          }
        },
        /*------------------------------
         PRIVACY POLICY
        ------------------------------*/
        {
            path: "/privacy-policy",
            name: "PrivacyPolicy",
            component: PrivacyPolicy,
            meta: {
              requiresAuth: false,
              fallback: null,
              layout: 'public'
            }
          },
        /*------------------------------
         Default
        ------------------------------*/
        {
          path: '*',
          redirect: '/home'
        },
    ]
});
router.routeCount = 0;
export default router;

router.beforeEach((to, from, next) => {
    var LS = router.app.$localStorage;

    if (to.matched.some(record => record.name == 'Logout')) {
        Auth.logout();
        return;

        //next()
    }
    Utils.checkBills()

    let possibleEntryPoints = _map(_filter(router.options.routes,o => {
        if(o.meta){
            return o.meta.permission
        }
        return false
    }),n => {
        return n.meta.permission
    })

    const v2Token = to.query?.v2_token
    if(!!v2Token) {
        LS.set('ACCESS_TOKEN', v2Token)
        axios.defaults.headers.Authorization = "Bearer " + v2Token;
        axios.defaults.headers.common['Authorization'] = "Bearer " + v2Token;
    }

    const v2Refresh = to.query?.v2_refresh
    if(!!v2Refresh) {
        LS.set('REFRESH_TOKEN', v2Refresh)
    }

    const v2Lang = to.query?.v2_lang
    if(!!v2Lang) {
        LS.set('bpz_lang', v2Lang)
        LS.set('bpz', v2Lang)
        LS.set('change_language', "defined")
    }

    setTimeout(function () {
        if (to.matched.some(record => record.meta.requiresAuth)) {

            // WHEN NOT LOGGED IN
            if (!Auth.isLoggedIn()) {
                // GET ACCESS TOKEN
                if (LS.get('ACCESS_TOKEN')) {
                    Auth.checkToken(LS.get('ACCESS_TOKEN'), function () {
                        let route;
                        // WHEN window.V.acl.permissions IS IN to.meta.permission
                        if(_indexOf(window.V.acl.permissions,to.meta.permission) != -1){
                            route = to
                        } else {
                            let entryPoints = _intersection(possibleEntryPoints,window.V.acl.permissions)
                            route = _find(router.options.routes,o => {
                                return o.meta.permission == entryPoints[0];
                            })
                        }

                        if(!!v2Lang){
                            LS.set(`BPZ_${Auth.getHash()}_LOCALE`, v2Lang)
                        }

                        window.V.loginMode = false;
                        next(route.path);

                    }, function(){
                        window.loginError = Utils.t('login.noPermission');
                        window.Vfc.$refs.loading.hide();
                        next({
                            path: '/login'
                        })
                    });
                } else {
                    window.Vfc.$refs.loading.hide();
                    var redirect = null;
                    if(to.name == "Logout") {
                        next({
                            path: '/login'
                        })
                    } else {
                        window.loginError = Utils.t('login.authRequired');
                        redirect = to.fullPath;
                        next({
                            path: '/login',
                            query: {redirect: redirect}
                        })
                    }
                }
            } else {
                window.V.loginMode = false;

                if (to.matched.some(record => record.name == 'Login')) {
                    next('/');
                }
                else {
                    next();
                }
            }
        } else {
            if (to.matched.some(record => record.name == 'Login')) {

                if(to.params.token != null){
                    Auth.checkToken(to.params.token, function () {
                        window.V.loginMode = false;
                        if (to.matched.some(record => record.name == 'Login')) {
                            next('/');
                        }
                        else {
                            next();
                        }

                    }, function(){
                        window.loginError = Utils.t('login.noPermission');
                        window.Vfc.$refs.loading.hide();
                        next({
                            path: '/login'
                        })
                    });
                }
                if(Auth.isLoggedIn()){
                    next('/');
                } else {
                    next();
                }
            } else {
                if(Auth.isLoggedIn()){
                    next();
                } else {
                    window.Vfc.$refs.loading.hide();
                    next();
                }
            }
        }
    }, 500)
})

router.afterEach((to, from) => {
    router.routeCount++;
    window.Vfc.$refs.messages.checkCountsForAutoDisappear();
    /*setTimeout(function(){
     window.Vfc.$refs.loading.hide();
     },500)*/
});

